import React, { useState } from 'react';
import { ArrowDownIcon } from '@components/Widgets/layout.components';
import { flex } from '@fabric-ui/theme';
import { Box, Collapse, SxProps } from '@mui/material';
import Typography from '@mui/material/Typography';

type CollapsedSectionProps = {
  title: React.ReactNode;
  isFocus: boolean;
  children: React.ReactNode;
  defaultCollapse?: boolean;
  sx?: SxProps;
  headerMinHeight?: number;
  textColor?: string;
  fontSize?: number;
};

const CollapsedSection: React.FC<CollapsedSectionProps> = ({
  isFocus,
  title,
  defaultCollapse = true,
  children,
  fontSize = 12,
  sx,
  headerMinHeight,
  textColor,
}) => {
  const [isCollapse, setIsCollapse] = useState(defaultCollapse);
  return (
    <Box
      sx={{
        ...flex.col,
        flexDirection: 'column',
        backgroundColor: isFocus ? 'var(--color-surface-interactive-modifier-default)' : undefined,
        borderRadius: '12px',
        gap: '12px',
        ...sx,
      }}>
      <Box
        onClick={() => setIsCollapse(!isCollapse)}
        sx={{
          gap: 1,
          cursor: 'pointer',
          minHeight: headerMinHeight,
          color: textColor || undefined,
          ...flex.itemsCenter,
        }}>
        {ArrowDownIcon(isCollapse)}
        <Typography sx={{ fontSize, color: textColor || 'var(--color-content-base-primary)', width: '100%' }} variant="h6">
          {title}
        </Typography>
      </Box>
      <Collapse in={isCollapse} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Box>
  );
};

export default CollapsedSection;
